import React from 'react';
import { AgGridReact } from 'ag-grid-react';

import {
  Button,
  Modal,
  Icon,
  Segment,
  Dimmer,
  Loader,
  Dropdown,
} from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';

const ImportGlossary = (props) => {
  const {
    onModalClose,
    onModalOpen,
    onChildModalClose,
    getPublicRecords,
    handleLanguageDropdownChange,
    onGridReadyPublic,
    onPublicSelectionChanged,
    handleGlossaryImport,
  } = props;
  return (
    <div>
      <Modal
        closeIcon
        style={{
          position: 'absolute',
          top: '2%',
          left: '10%',
          transform: 'transform(-50%, -50%)',
          width: '80%',
          height: 'auto',
        }}
        onClose={onModalClose}
        onOpen={onModalOpen}
        open={props.state.importModalState}
        //   trigger={<Button basic color='green' onClick={getPublicRecords}><Icon name='download'/> Import Glossary</Button>}
        trigger={
          <button
            type="button"
            className="btn btn-primary btn-md rounded-pill"
            onClick={getPublicRecords}
            style={{ color: 'white', margin: '11px', background: '#00e6e3' }}
          >
            <Icon name="download" />
            Import Glossary
          </button>
        }
      >
        <Modal.Header>Import Glossary</Modal.Header>
        <Modal.Content>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px' }}>
              Language:
              <Dropdown
                placeholder="Select Language"
                selection
                search
                clearable={true}
                multiple={false}
                labeled={true}
                options={props.state.languageOptions}
                value={props.state.publicLanguage}
                onChange={handleLanguageDropdownChange}
              />
            </div>
            <div>
              {props.state.publicData.length > 0 ? (
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: '430px',
                    width: 'auto',
                  }}
                >
                  <AgGridReact
                    columnDefs={props.state.publicData[0].columnDefs}
                    defaultColDef={props.state.defaultColDef}
                    rowData={props.state.publicData[0].rowData}
                    rowSelection={props.state.rowSelection}
                    onGridReady={onGridReadyPublic}
                    onSelectionChanged={onPublicSelectionChanged}
                    paginationPageSize={8}
                    pagination={true}
                    suppressRowClickSelection={true}
                  ></AgGridReact>
                </div>
              ) : (
                <div>
                  <Segment style={{ width: '650px', height: '425px' }}>
                    <Dimmer
                      active
                      inverted
                    >
                      <Loader inverted>Loading</Loader>
                    </Dimmer>
                  </Segment>
                </div>
              )}
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <div>
            <Button
              color="black"
              onClick={onModalClose}
            >
              Cancel
            </Button>
            <Button
              content="Import Records"
              labelPosition="right"
              icon="save"
              positive
              onClick={handleGlossaryImport}
            />
            <Dimmer
              active={props.state.importRecordsLoader}
              inverted
            >
              <Loader inline />
            </Dimmer>
          </div>
        </Modal.Actions>
        <Modal
          style={{
            position: 'absolute',
            top: '8%',
            left: '20%',
            transform: 'transform(-50%, -50%)',
            width: '60%',
            height: '80%',
          }}
          onClose={onChildModalClose}
          open={props.state.childModalState}
        >
          {props.state.failedData.length > 0 ? (
            <Modal.Header>
              Failed to import {props.state.failedData[0].rowData.length}{' '}
              records out of {props.state.selectedRowsPublic.length} records
            </Modal.Header>
          ) : (
            <Modal.Header>Import Summary</Modal.Header>
          )}
          <Modal.Content>
            <div>
              Source and Language already exists for the following records,
              consider modifying or deleting the existing records
              <hr />
              {props.state.failedData.length > 0 ? (
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: '380px',
                    width: 'auto',
                  }}
                >
                  <AgGridReact
                    columnDefs={props.state.failedData[0].columnDefs}
                    defaultColDef={props.state.defaultColDef}
                    rowData={props.state.failedData[0].rowData}
                    paginationPageSize={6}
                    pagination={true}
                    suppressRowClickSelection={true}
                  ></AgGridReact>
                </div>
              ) : (
                <div>
                  <Segment style={{ width: '650px', height: '425px' }}>
                    <Dimmer
                      active
                      inverted
                    >
                      <Loader inverted>Loading</Loader>
                    </Dimmer>
                  </Segment>
                </div>
              )}
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button
              icon="check"
              content="Done"
              onClick={onChildModalClose}
            />
          </Modal.Actions>
        </Modal>
      </Modal>
    </div>
  );
};

export default ImportGlossary;
